export default function request (state = {}, action) {
  if (action.request) {
    return {
      ...state,
      [action.request.id]: {
        isPending: action.request.isPending,
        error: action.request.error
      }
    }
  }

  return state
}

export let selectIsAnyRequestPending = (state) => {
  return Object.keys(state.request).some(key => {
    let action = state.request[key] || {}
    return action.isPending
  })
}

export let selectIsRequestPending = (state, action) => {
  return (state.request[action.event.name] || {}).isPending === true
}

export let selectRequestError = (state, action) => {
  return (state.request[action.event.name] || {}).error
}



// WEBPACK FOOTER //
// ./client/src/util/requestReducer.js